class SPFormField extends HTMLElement {
	connectedCallback() {
		this.form = this.closest('[data-form]');
		this.fieldId = this.dataset.fieldId;
		this.fieldType = this.dataset.fieldType;
		this.field = this.querySelector('input, textarea, select');
		if (!this.field) return;

		this.field.addEventListener('input', this.onInput.bind(this));
		this.field.addEventListener('change', this.onChange.bind(this));
	}

	onInput(event) {
		// Validate values.
		if (this.field.min) this.checkMin(event);
		if (this.field.max) this.checkMax(event);
		if (this.field.dataset.setOtherField) this.setOtherField(event);
	}

	onChange(event) {
		// Validate values.
		if (this.field.dataset.blankDefault) this.checkBlankDefault(event);
	}

	/**
	 * Check if the field value is less than the minimum value.
	 */
	checkMin() {
		if (this.field.value === '') return;
		if (parseFloat(this.field.value) >= parseFloat(this.field.min)) return;
		this.field.value = this.field.min;
	}

	/**
	 * Check if the field value is greater than the maximum value.
	 */
	checkMax() {
		if (this.field.value === '') return;
		if (parseFloat(this.field.value) <= parseFloat(this.field.max)) return;
		this.field.value = this.field.max;
	}

	/**
	 * Check if the field value is blank, and set default value.
	 */
	checkBlankDefault() {
		if (this.field.value === '') this.field.value = this.field.dataset.blankDefault;
	}

	/**
	 * Set the value of another field based on this field's value.
	 */
	setOtherField(event) {
		/**
		 * @typedef {Object} OtherFieldCases
		 * @property {string} when - When the value matches this... (when true, matches when value is not blank)
		 * @property {string} set - Set this value on the other field
		 * @property {string[]|boolean} [override] - Only if the other field's value matches the override. If true, override any value.
		 */
		
		/**
		 * @type {Object.<string, { when: string, set: string, override: string[] }[]>}
		 */
		const otherFields = JSON.parse(this.field.dataset.setOtherField);
		if (typeof otherFields !== 'object') return;

		Object.entries(otherFields).forEach(([name, cases]) => {
			if (!cases || !cases.length) return;

			const otherField = this.form[name];
			if (!otherField) return;

			let valueSet = false;

			cases.forEach(({ when, set, override = [] }) => {
				if (when === true ? this.field.value === '' : this.field.value !== when) return;
				if (override !== true && !override.includes(otherField.value)) return;
				otherField.value = set;
				valueSet = true;
			});
			if (!valueSet) return;

			// Trigger change event on the other field.
			if (event.simulated) return;
			const otherEvent = new Event('input', { bubbles: true });
			otherEvent.simulated = true;
			otherField.dispatchEvent(otherEvent);
		});
	}

	setFeedback(status, message) {
		this.clearFeedback();

		this.dataset.status = status;
		let feedback = this.querySelector(`[data-field-feedback="${this.fieldId}"]`);
		if (!feedback) return console.error('No feedback element found for field:', this.fieldId);

		const statusIcon = SunergoPlatform.templates.clone(`field-status--${status}`);
		if (statusIcon) feedback.appendChild(statusIcon);
		else console.warn(`Status Icon "field-status--${status}" not found for field:`, this.fieldId);

		if (message) {
			const messageNode = document.createTextNode(message);
			feedback.appendChild(messageNode);
		}
	}

	clearFeedback() {
		this.removeAttribute('data-status');
		const feedback = this.querySelector(`[data-field-feedback="${this.fieldId}"]`);
		if (feedback) feedback.innerHTML = '';
		else console.error('No feedback element found to clear for field:', this.fieldId);
	}
}
customElements.define('sp-form-field', SPFormField);
